import { createCsv } from '@fitogest/reactive-form-builder/csv';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { BaseView } from '../../../base-view';
import moment, { Moment } from 'moment';
import { Filtering } from 'src/app/service/filtering/filtering';
import { StorageManager } from '../../../../common/storage-manager.class';

import { TareaPlantacionModel } from 'src/app/models/tareas/tarea-plantacion.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { TareasPlantacionEnvironmentDefinition } from './environment-variables';
import { TareasPlantacionFormDefinition } from './tareas-plantacion-form/form-control/form-definition';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-tareas-plantacion-general',
    standalone: false,
    templateUrl: './tareas-plantacion.component.html',
    styleUrls: ['./tareas-plantacion.component.scss']
})
export class TareasPlantacionComponent extends BaseView<TareaPlantacionModel> implements OnInit, AfterViewInit {
    public env: TareasPlantacionEnvironmentDefinition = new TareasPlantacionEnvironmentDefinition();
    public form: TareasPlantacionFormDefinition | null = null;
    public rolUser = StorageManager.getUser().rol;
    public hiddenButtonDelete = false;

    public appName = this.env.appName;
    public serverUrl = this.env.serverUrl;
    public fincaName = this.env.fincaName;
    public hasClients = this.env.hasClients;
    public userCanSeeClientes = this.env.canSeeClientes;

    public getRequest: RequestHandler<TareaPlantacionModel[]> = this.tareasApi.plantacion.GET;
    public deleteRequest: RequestHandler<TareaPlantacionModel> = this.tareasApi.plantacion.DELETE;
    public pathToForm = 'plantacion';
    public menuItemId = 'plantacion';

    public override filtering: Filtering<TareaPlantacionModel> = new Filtering<TareaPlantacionModel>();
    public override canShow: Record<string, boolean> = {};
    public override model: TareaPlantacionModel = {};

    public optionsSelectButton = [
        { label: 'Todos', value: 0 },
        { label: 'Si', value: 1 },
        { label: 'No', value: 2 }
    ];

    public readonly realizadoControl = new FormControl<number>(0, { nonNullable: true });
    public selectedYears = 0;

    public cols: ColInterface[] = [
        { field: 'cliente_nombre', header: 'Cliente', filter: '' },
        { field: 'trabajadores_nombres', header: 'Empleado', filter: '' },
        { field: 'finca', header: this.fincaName, filter: '' },
        { field: 'fecha', header: 'Fecha', filter: '' },
        { field: 'hora_inicio', header: 'Hora Inicio', filter: '' },
        { field: 'hora_fin', header: 'Hora Fin', filter: '' },
        { field: 'horas', header: 'Horas', filter: '' },
        { field: 'cultivo', header: 'Cultivo', filter: '', visible: this.appName === 'detorres' },
        { field: 'variedad', header: 'Variedad', visible: this.appName === 'detorres' },
        { field: 'cantidad', header: 'Cantidad', visible: this.appName === 'detorres' },
        { field: 'unidad_medidad', header: 'Unidad de Medida', visible: this.appName === 'detorres' },
        { field: 'prioridad', header: 'Prioridad/Realizada', filter: '' },
        { field: 'observaciones', header: 'Observaciones', filter: '' }
    ];

    public totalHoras: Moment | string = '00:00';
    public auxTotalHoras: Moment | string = '00:00';

    public fecha: { inicio: string; fin: string } = {
        inicio: '',
        fin: '',
    };

    constructor(
        public tareasApi: TareasApiService,
        private dashboard: DashboardService,
        private router: Router,
    ) {
        super(dashboard, tareasApi.plantacion.GET, tareasApi.plantacion.DELETE);
    }

    public ngOnInit(): void {
        if (this.env.showTareasMto && this.rolUser !== 'admin') {
            this.hiddenButtonDelete = true;
        }

        this.dashboard.setSubmenuItem('tareas', this.menuItemId);
        this.realizadoControl.setValue(2);
        this.addPlantacionFilters();
    }

    public add(): void {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-' + this.pathToForm]);
        }
    }

    public edit(data: TareaPlantacionModel): void {
        this.router.navigate(['dashboard', 'editar-plantacion', data.id]);
    }

    public duplicate(data: TareaPlantacionModel): void {
        this.router.navigate(['dashboard', 'duplicar-plantacion', data.id]);
    }

    public override deleteRegister(): void {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public override show(modal: string, data: TareaPlantacionModel): void {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new TareasPlantacionFormDefinition(formType, data);
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },
                };
            } else if (value === 'Realizada') {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },
                };
            }
        }

        if (col.field === 'trabajadores_nombres') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }

        if (col.field === 'observaciones') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }

        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string): string {
        return value;
    }

    public formatDate(date: string): string {
        moment.locale('es');
        return moment(date, 'DD/MM/YYYY').format('LL');
    }

    public filtrar(): void {
        this.filtering.filter();
        this.updateFooter();
    }

    public downloadCsv(): void {
        this.form = new TareasPlantacionFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Partial<TareaPlantacionModel>,
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as TareaPlantacionModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Plantación.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }
    }

    public override updateFooter(): void {
        this.sum();
    }

    public override sum(): void {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;

        (this.filtering.value || []).forEach((tareas, index) => {
            const horasTotales = (tareas as TareaPlantacionModel).horas;

            if (horasTotales != null && horasTotales.length > 0) {
                contador++;
                const horaMinuto = horasTotales.split(':');

                this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
            }

            if (index + 1 >= (this.filtering.value as TareaPlantacionModel[]).length) {
                let minutos = moment(this.totalHoras).format('mm');
                let diferencia = moment(this.totalHoras).diff(this.auxTotalHoras);

                if (minutos.toString().length === 0) {
                    minutos = '00';
                }

                if (minutos.toString().length === 1) {
                    minutos = '0' + minutos.toString();
                }
                diferencia = diferencia / (1000 * 60 * 60);
                diferencia = Math.abs(Math.floor(diferencia));
                this.totalHoras = diferencia + ':' + minutos;

                if (contador === 0) {
                    this.totalHoras = '00:00';
                }
            }
        });

        if (contador === 0) {
            this.totalHoras = '00:00';
        }
        this.filtering.filter();
    }

    public getFechaInicio(event: string | Date): void {
        this.fecha.inicio = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
    }

    public getFechaFin(event: string | Date): void {
        this.fecha.fin = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
    }

    private getFilterDate(event: string | Date): string {
        const date = event instanceof Date ? moment(event) : moment(event, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

        return date.isValid() ? date.format('YYYY-MM-DD') : '';
    }

    public ngAfterViewInit(): void {
        this.tareasApi.plantacion.GET.response(() => {
            this.updateFooter();
            this.sum();
        });
    }

    private addPlantacionFilters(): void {
        this.filtering.addFilter((copy: TreeNode<TareaPlantacionModel>[] | void) =>
            (copy as TreeNode<TareaPlantacionModel>[]).filter(row => {
                const tareaPlantacion = row as TareaPlantacionModel;

                switch (this.realizadoControl.value) {
                case 1:
                    return ['Realizada'].includes(tareaPlantacion.prioridad ?? '');
                case 2:
                    return !['Realizada'].includes(tareaPlantacion.prioridad ?? '');
                default:
                    return true;
                }
            }));

        if (StorageManager.getUser().rol !== 'admin' && this.appName !== 'detorres') {
            this.filtering.addFilter((copy: TreeNode<TareaPlantacionModel>[] | void) =>
                (copy as TreeNode<TareaPlantacionModel>[]).filter(row => {
                    const tareaPlantacion = row as TareaPlantacionModel;

                    if (tareaPlantacion.ids_trabajadores != null) {
                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaPlantacion.ids_trabajadores as string).split(';');

                        if (listaTrabajadores.find(id => id === idTrabajador?.toString())) {
                            return true;
                        }
                    }

                    return false;
                }));
        }

        this.filtering.addFilter((copy: TreeNode<TareaPlantacionModel>[] | void) =>
            (copy as TreeNode<TareaPlantacionModel>[]).filter(row => {
                const tareaPlantacion = row as TareaPlantacionModel;

                if (!this.fecha.inicio || !this.fecha.fin || !tareaPlantacion.fecha) {
                    return true;
                }

                const arrayFecha = tareaPlantacion.fecha.toString().split('/');
                const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];

                return moment(this.fecha.inicio).diff(fechaAux) <= 0 && moment(this.fecha.fin).diff(fechaAux) >= 0;
            }));
    }
}
